module.exports = __webpack_public_path__ + "h5/img/noNews.38d4dd72.png";